export default {
    common: {
        title: 'Edit Image',
        cancel: 'Cancel',
        save: 'Save',
        crop: 'Crop',
        adjustments: 'Adjustments',
        filters: 'Filters',
        frames: 'Frames',
        overlays: 'Overlays',
        text: 'Text',
        stickers: 'Stickers',
        brush: 'Brush',
        ai: 'Create image using AI',
        reset: 'Reset',
        comingSoon: 'Coming Soon...',
    },
};
